import gql from 'graphql-tag';

export default fields => gql`
mutation ($input: CreateEtlPackageExecutionInput!) {
    createEtlPackageExecution (input: $input) {
        __typename
        ${[...['id'].concat(fields)]}
    }
}`;


// WEBPACK FOOTER //
// ./src/GraphQueries/EtlPackageExecutions/NewMutation.js